import { render, staticRenderFns } from "./AwardDetail.vue?vue&type=template&id=3a6f1df0&scoped=true&"
import script from "./AwardDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardDetail.vue?vue&type=style&index=0&id=3a6f1df0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f1df0",
  null
  
)

export default component.exports